module.exports = __webpack_public_path__ + "img/chat_bot_illustrator_2.0b585450.svg";